import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { Outlet } from 'react-router-dom';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { VIEWER } from '../utilities/queries';
import dayTheme from '../themes/day';
import nightTheme from '../themes/night';

const ThemeLayout = ({ hasChildren, children }) => {
  const { data } = useQuery(VIEWER, {
    skip: !localStorage.getItem('token'),
  });
  const [theme, setTheme] = useState(
    localStorage.getItem('nightMode') === 'true' ? nightTheme : dayTheme
  );

  useEffect(() => {
    if (data && data.viewer.nightMode !== localStorage.getItem('nightMode')) {
      setTheme(data && data.viewer.nightMode ? nightTheme : dayTheme);
      localStorage.setItem('nightMode', data.viewer.nightMode);
    }
  }, [data]);

  const DarkRoot = createGlobalStyle`
    :root {
      color-scheme: dark light;
    }
  `;

  return (
    <ThemeProvider theme={theme}>
      {theme === nightTheme && <DarkRoot />}
      {hasChildren ? children : <Outlet />}
    </ThemeProvider>
  );
};

export default ThemeLayout;
